function OrbitalDiagram({orbitsStr}){
    const subShells = {
        s: 2,
        p: 6,
        d: 10,
        f: 14
    }
    const orbitsArr = orbitsStr.split(" ");

    const drawBlocks = (numberOfBlocks, numberOfElectrons)=>{
        return <>
        
        {[...Array(numberOfBlocks).keys()].map((i) =>{  // Creating Array of length of number of needed blocks
            // Checking if this block contains electrons 
            // For example: 3p4, only first two block out of three are full of electrons 
            // index 0 : contains electron num 1 (2*i+1) and 2 (2*i+2), index 1: contains electron number 3 (2*i+1) and 4 (2*i+2)
            return <div className="block" key={i}> {numberOfElectrons >= (2*i+1) ? "\u2191" : ""}{numberOfElectrons >=  (2*i+2) ? "\u2193" : ""}</div> 
            
        })}
        
        </>

    }

    return <div className="orbital-diagram">
        {orbitsArr.map((orbit, index)=>{
            const level = Number(orbit[0]);
            const type = orbit[1];
            const numberOfElectrons = Number(orbit.slice(2));
            const numberOfBlocks = subShells[type] / 2;
            
            return (
            <div className = {"orbit orbit-" + type} key={index}>
                <div className="blocks">
                    {drawBlocks(numberOfBlocks, numberOfElectrons)}
                </div>
                <p>{level + type}</p>
        </div>)
        })}
    </div>

}


export default OrbitalDiagram;